// 设置 rem 函数
const baseSize = 16;

function setRem() {
  // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
  const scale = document.documentElement.clientWidth / 1920;
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整
  const fontSize =
    baseSize * Math.min(scale, 2) > 10 ? baseSize * Math.min(scale, 2) : 10;
  document.documentElement.style.fontSize = fontSize + "px";


  // const screenWidth = window.innerWidth;
  // // 设计稿宽度为 1920px，基准字体大小为 16px
  // const baseFontSize = 16;
  // const fontSize = screenWidth / 120; // 1rem = 16px，即 1rem = 16/16 = 1px
  // document.documentElement.style.fontSize = fontSize < baseFontSize ? baseFontSize + 'px' : fontSize + 'px';
}

setRem(); // 初始化调用

// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
